import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import './dataTableShipment.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {compareString} from '../../util/utility.js'
import { userConstants } from '../../constants';
class DataTableShipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            pageSize: 10,
            records: 0,
            sortColumnName: '',
            sortOrder: '',
            blocking: true,
            role: '',
            shipmentList: [],
            showTable: '',
            deleteData: [],
            multipleDownload: [],
            multipleDelete:[],
            distributor:'',
            depot:'',
            isChecked:true,
        }
        this.addLink = this.addLink.bind(this);
        this.handleBulkDownload = this.handleBulkDownload.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        
    }

    addLink(cell, row) {
       // console.log('cell:', cell, 'row:', row);
        return (<a href="#" onClick={this.props.onDownloadHandler}
                filename={cell}>
            {cell}
        </a>)
    }

    handleDelete = () => {
        console.log('this. is', this);
        console.log('MultipleDelete:',this.state.multipleDelete);
        this.props.onMultipleDeleteHandler(this.state.multipleDelete);
    }

    handleBulkDownload = () => {
        console.log('Handle Bulk Download this. is', this);
        console.log('MultipleDownload:',this.state.multipleDownload);
        this.props.onBulkDowloadHandler(this.state.multipleDownload);
    }

    pageChanged(pageNumber) {
        console.log('pageNumber:', pageNumber);
        this.setState({ pageNumber: pageNumber })
        this.setState({ currentPage: pageNumber })
        if(this.state.sortColumnName==='customerDetail'){
            if(this.state.distributor){
                this.state.sortColumnName="distributor"; 
            }
            if(this.state.depot){
                this.state.sortColumnName="depot";
            }
        }
        this.props.paginationHandler(pageNumber, this.state.pageSize, this.state.sortColumnName, this.state.sortOrder);
    }

    sortChanged(sortColumn, order) {
        console.log('sortColumn:', sortColumn, 'order:', order);
        this.setState({ sortColumnName: sortColumn });
       // this.setState({ currentPage: this.state.pageNumber });
        //let sortOrder = order.toString().toLowerCase() === 'asc' ? 'desc' : 'asc';
        let sortOrder = order;
        this.setState({ sortOrder: sortOrder });
        if(sortColumn==='customerDetail'){
            if(this.state.distributor){
                sortColumn="distributor.code"; 
            }
            if(this.state.depot){
                sortColumn="depot.code";
            }
        }
          if(sortColumn==='docType'){
                sortColumn="docType.docType";
            }
            if(sortColumn==='transType'){
                sortColumn="transType.transType";
            }
            if(sortColumn==='forwarder'){
                sortColumn="forwarder.code";
            }
        
        this.props.paginationHandler(this.state.pageNumber, this.state.pageSize, sortColumn, sortOrder);
    }
    sizePerPageListChange(sizePerPage) {
        this.setState({ pageSize: sizePerPage });
        this.props.paginationHandler(this.state.pageNumber, sizePerPage, this.state.sortColumnName, this.state.sortOrder);
    }

    renderShowsTotal(start, to, total) {
        console.log('start:', start, 'to:', to, 'total:', total, '--', this.state.records);
        var text = "Showing " + start + " to " + to + " of " + this.state.records + " records.";
        return (
            <p style={{ color: 'blue' }}>
                {text}
            </p>
        );
    }
    handleOnSelect = (row, isSelect) => {
        console.log('rowSelect:',row,'isSelect:',isSelect);
       // var rowshipmentLink=row.shipmentLink;
        if (isSelect) {
            // this.state.multipleDownload.push({rowshipmentLink});
             this.setState(() => ({
        //     multipleDownload: row.shipmentLink],
        //     //multipleDownload:multipleDownload.concat(this.state.multipleDownload),
               multipleDownload: [...this.state.multipleDownload, row.shipmentLink], 
               multipleDelete:[...this.state.multipleDelete,row.shipmentLink] 
               }));
               this.setState({isChecked:false});
        //this.state.multipleDownload.push({rowshipmentLink})
        } else  {
          this.setState(() => ({
        multipleDownload:this.state.multipleDownload.filter(x => x !== row.shipmentLink),
        multipleDelete: this.state.multipleDelete.filter(x => x !==row.shipmentLink)
           }));
       // this.state.multipleDownload.filter(x => x !== row.shipmentLink)
    }
        console.log('Multi',this.state.multipleDownload);
      }
      handleOnSelectAll =(isSelect,rows) =>{
          console.log('Rows:',rows);
        const multipleShipmentLink = rows.map(r => r.shipmentLink);
        if(isSelect) {
            this.setState(() =>({
                multipleDownload:multipleShipmentLink,
                multipleDelete:multipleShipmentLink
            }));
        }
            else{
                this.setState(() => ({
                    multipleDownload:[],
                    multipleDelete:[]
                  }));
        }
    }
    selectRowProp = {
        mode: "checkbox",
        //clickToSelect: true,
        checkbox:true,
        bgColor: "rgb(238, 193, 213)" ,  
        onSelect:this.handleOnSelect,
        onSelectAll: this.handleOnSelectAll
          
      };
    // selectRow={
    //     mode:"checkbox",
    //     clickToSelect:true,
    //     onSelect:this.handleOnSelect,
    //     bgColor: "rgb(238, 193, 213)"
    // }
    componentWillReceiveProps(nextProps) {
        console.log('recieveProps:', nextProps);
        // this.setState(() => ({
        //     multipleDelete:[]
        //   })); 
        // console.log('this.state.selectRowProp:',this.state.multipleDelete)
        if(nextProps.bulkClear){
            this.setState(() => ({
                multipleDownload:[]
            })); 
        }
        if(nextProps.deleteStatus){
               this.setState(() => ({
                multipleDelete:[]
            })); 
         }
       console.log('this.state.selectRowProp:',this.state.multipleDelete)
        if (nextProps.data) {
            if (this.props.searchClear === true) {
                this.setState({ currentPage: 1 });
            }
            this.setState({ shipmentList: nextProps.data.dtoList });
            this.setState({ records: nextProps.data.records });
            this.setState({ role: nextProps.role });
            this.setState({ showTable: nextProps.showShipMentResult })
            this.setState({distributor:nextProps.data.distributor})
            this.setState({depot:nextProps.data.depot})

        }
    }
    componentWillMount() {
        // console.log("this.props.showResults:" + this.props.showResults);
        console.log("this.props datatable" + this.props);
    }


    render() {
        console.log('search clear:', this.props.searchClear);

        const options = {
            page: this.state.currentPage,
            sizePerPage: 10,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationShowsTotal: this.renderShowsTotal.bind(this),
            onPageChange: this.pageChanged.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            onSortChange: this.sortChanged.bind(this)
        };

        console.log('sortTable this.props datatable', this.props);
        console.log('state ShipmentList', this.state.shipmentList);
        console.log('state ', this.state);
        return (
            <div className='table'>
                { compareString( this.state.role,userConstants.EDOC_TME_ADMIN) ? <div>
                    {this.props.showShipMentResult && this.state ? <div>
                       
                        <BootstrapTable data={this.state.shipmentList} options={options} pagination={true} selectRow={this.selectRowProp} keyField={'id'} fetchInfo={{ dataTotalSize: this.state.records }} remote={true}>
                            <TableHeaderColumn  dataField='shipmentId' dataAlign="center" dataSort={true} >Shipment Id</TableHeaderColumn>
                            <TableHeaderColumn  dataField='docType' dataAlign="center" dataSort={true}>Document Type</TableHeaderColumn>
                            <TableHeaderColumn columnTitle dataField='customerDetail' dataAlign="center" dataSort={true}>Customer Name </TableHeaderColumn>
                            <TableHeaderColumn dataField='forwarder' dataAlign="center" dataSort={true}>Forwarder</TableHeaderColumn>
                            <TableHeaderColumn dataField='transType' dataAlign="center" dataSort={true}>Transportation Type</TableHeaderColumn>
                            <TableHeaderColumn dataField='shipmentDate' dataAlign="center">Shipment Date</TableHeaderColumn>
                            <TableHeaderColumn width={'28%'} dataField='shipmentLink' dataFormat={this.addLink} dataAlign="center">Shipment Link</TableHeaderColumn>
                        </BootstrapTable>
                        <button className="button" onClick={this.handleDelete}>Delete</button>
                        <button className="button" onClick={this.handleBulkDownload}>Bulk Download</button>
                    </div> : null}
                </div> :
                    <div className='table'>
                        {this.props.showShipMentResult && this.state ?<div>
                            <BootstrapTable data={this.state.shipmentList} options={options} pagination={true} selectRow={this.selectRowProp} keyField={'id'} fetchInfo={{ dataTotalSize: this.state.records }} remote={true}>
                                <TableHeaderColumn dataField='shipmentId' dataAlign="center" dataSort={true}>Shipment Id</TableHeaderColumn>
                                <TableHeaderColumn  dataField='docType' dataAlign="center" dataSort={true}>Document Type</TableHeaderColumn>
                                <TableHeaderColumn columnTitle dataField='customerDetail' dataAlign="center" dataSort={true} >Customer Name </TableHeaderColumn>
                                <TableHeaderColumn dataField='forwarder' dataAlign="center" dataSort={true}>Forwarder</TableHeaderColumn>
                                <TableHeaderColumn dataField='transType' dataAlign="center" dataSort={true}>Transportation Type</TableHeaderColumn>
                                <TableHeaderColumn dataField='shipmentDate' dataAlign="center">Shipment Date</TableHeaderColumn>
                                <TableHeaderColumn width={'28%'} dataField='shipmentLink' dataFormat={this.addLink} dataAlign="center">Shipment Link</TableHeaderColumn>
                            </BootstrapTable>
                             <button className="button" onClick={this.handleBulkDownload}>Bulk Download</button>
                             </div> : null}
                    </div>
                }
            </div>
        )
    }

}
export default DataTableShipment;